export default "__VITE_ASSET__Bs04sOUI__"